import(/* webpackMode: "eager" */ "/var/www/higuard/frontend/src/app/not-found.tsx");
